import Header from 'components/navigation/Header';
import { historySummary, lookupMed } from 'helpers/medicationHelpers';
import moment from 'moment';
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';

export default function HistorySummary() {
	const params = useParams();
	const medId = params.id;
	const med = lookupMed(medId);
	const navigate = useNavigate();
	console.log('HistorySummary', medId);

	const summary = historySummary(medId);
	//console.log('summary', summary);
  
  return (
    <div className='mcard'>
      <Header title='History Summary' help='Historysummary' />
      {medId && 
      <div className='mcard-header'>
          <div className='p-2 font-bold text-2xl text-left'>
            {med.name}
          </div>
		  <div className='p-2'>
			<button
				className='rawBtn px-2 border-2 border-green-200 cursor-pointer'
				onClick={()=>navigate(-1)}
			>
				Back
			</button>
		  </div>
      </div>
      }
			{/* <div className='mcard-header'>Medication History</div> */}
			<div id='scroll_area' className='lcard mb-1'>
				<div className='flex flex-col w-full justify-center items-center'>
					<table className='w-10/12 mt-4 text-2xl font-semibold'>
						<thead></thead>
						<tbody>
							{summary.map((s, ix) => {
								const date = moment().startOf('day').subtract(ix, 'd').format('MM/DD/YYYY');
								return (
									<tr className='zebra' key={ix}>
										<td className='pl-4 py-2'>{date}</td>
										<td>{s}</td>
									</tr>
								)
							})
							}
						</tbody>
					</table>
				</div>
				<div style={{ height: '60px' }} />
			</div>
		</div>
  )
}

